import {
  ADD_UPDATE_CUSTOMER_FAILURE,
  ADD_UPDATE_CUSTOMER_REQUEST,
  ADD_UPDATE_CUSTOMER_SUCCESS,
  FETCH_LTL_CUSTOMER_LIST_FAILURE,
  FETCH_LTL_CUSTOMER_LIST_REQUEST,
  FETCH_LTL_CUSTOMER_LIST_SUCCESS,
} from "./actionTypes";
import { LtlCustomer } from "./types";

export const fetchLTLCustomerListRequest = (
  url: string,
  payload: {
    pageNumber: number;
    pageSize: number;
    sortColumn: string;
    sortOrder: string;
    searchValue: string;
  }
) => ({
  type: FETCH_LTL_CUSTOMER_LIST_REQUEST,
  url,
  payload,
});

export const fetchLTLCustomerListSuccess = (
  ltlCustomerList: LtlCustomer[],
  totalCount: number
) => ({
  type: FETCH_LTL_CUSTOMER_LIST_SUCCESS,
  payload: { ltlCustomerList, totalCount },
});

export const fetchLTLCustomerListFailure = (error: string) => ({
  type: FETCH_LTL_CUSTOMER_LIST_FAILURE,
  payload: error,
});

export const addUpdateCustomerRequest = (
  url: string,
  payload: any,
  callback: unknown
) => ({
  type: ADD_UPDATE_CUSTOMER_REQUEST,
  url,
  payload,
  callback,
});

export const addUpdateCustomerSuccess = (successMessage: string) => ({
  type: ADD_UPDATE_CUSTOMER_SUCCESS,
  payload: { successMessage },
});

export const addUpdateCustomerFailure = (error: string) => ({
  type: ADD_UPDATE_CUSTOMER_FAILURE,
  payload: error,
});
